/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */

import { isNullOrUndefined } from '..';

import _transform from 'lodash/transform';
import _isEqual from 'lodash/isEqual';
import _isObject from 'lodash/isObject';
import _isArray from 'lodash/isArray';

const isMLObject = obj => obj?.hasOwnProperty('__ML_CLASS_OBJECT__');

export default function difference(object: any, base: any) {
	const objectEmpty = isNullOrUndefined(object);
	const baseEmpty = isNullOrUndefined(base);

	if (objectEmpty && !baseEmpty) {
		return base;
	}
	if (baseEmpty && !objectEmpty) {
		return object;
	}

	const changes = (o: any, b: any) =>
		_transform(o, (result: any, value: any, key: any) => {
			if (b && !_isEqual(value, b[key])) {
				if (_isArray(value)) {
					result[key] = o[key];
				} else if (isMLObject(value) && isMLObject(b[key])) {
					if (!_isEqual(value.getData(), b[key].getData())) {
						result[key] = changes(value.getData(), b[key].getData());
					}
				} else {
					result[key] =
						_isObject(value) && _isObject(b[key]) ? changes(value, b[key]) : value;
				}
			}
		});

	return changes(object, base);
}
